/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
import React from "react";
import { RichText } from "prismic-reactjs";
import { linkResolver } from "@utils";

export default React.memo(({ content }) => {
  return content && RichText.render(content, linkResolver);
});
